import React, { useEffect, useRef, useState } from "react";
import { Button, Nav, Navbar } from "react-bootstrap";
import TelegramIcon from "../assets/images/telegramIcon.svg";
import WhatsappIcon from "../assets/images/whatsappIcon.svg";
import MoonLight from "../assets/images/moon.svg";
import SunLight from "../assets/images/sunny.svg";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import MenuIcon from "../assets/images/menu-icon.png";
import MobLeftbar from "./MobLeftbar";
import GamesSearchModal from "../views/components/GamesSearchModal";
import { APP_CONST } from "../config/const";
import { isMobile } from "react-device-detect";
import { useOutsideAlerter } from "../hooks/useOutsideClick";
import ModalWrapper from "./ModalWrapper";
import { getNotifications } from "../redux/app/actions";
import { AiOutlineClose } from "react-icons/ai";

const Header = () => {
  const navigate = useNavigate();
  const [showAuthModals, setShowAuthModals] = useState(false);
  const [defaultModal, setDefaultModal] = useState("login");
  const { appDetails } = useSelector((state) => state.app);
  const [isClassAdded, setIsClassAdded] = useState(false);
  const [showMobileSideBar, setShowMobileSideBar] = useState(false);
  const containerRef = useRef(null);
  const [websiteNotifications, setWebsiteNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(true);
  useOutsideAlerter(containerRef, setShowMobileSideBar);

  useEffect(() => {
    const isClassAddedLocalStorage = localStorage.getItem("isClassAdded");
    if (isClassAddedLocalStorage) {
      setIsClassAdded(true);
      document.body.classList.add("light-theme");
    }

    loadNotifications();
  }, []);

  const loadNotifications = async () => {
    // get notifications
    const notifications = await getNotifications();
    if (notifications && notifications?.data?.data) {
      setShowNotifications(true);
      setWebsiteNotifications(notifications?.data?.data);
    }
  };

  const toggleClass = () => {
    if (isClassAdded) {
      setIsClassAdded(false);
      localStorage.removeItem("isClassAdded");
      document.body.classList.remove("light-theme");
    } else {
      setIsClassAdded(true);
      localStorage.setItem("isClassAdded", true);
      document.body.classList.add("light-theme");
    }
  };

  const handleModalShow = (modalName) => {
    setShowAuthModals(true);
    setDefaultModal(modalName);
  };

  return (
    <>
      {(websiteNotifications.length && showNotifications && (
        <div className="marqu">
          <marquee>
            {websiteNotifications.map((notf, idx) => (
              <label style={{ marginRight: "30px" }} key={idx}>
                {notf?.content}
              </label>
            ))}
          </marquee>
          <span onClick={() => setShowNotifications(false)}>
            <AiOutlineClose />
          </span>
        </div>
      )) ||
        null}
      <header className="header header_bfrlgn">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="d-flex align-items-center">
                <Button
                  variant="primary menu-btn"
                  onClick={() => setShowMobileSideBar((p) => !p)}
                  className="d-block d-md-none"
                  id="menuSidebarHandler"
                >
                  <img
                    src={MenuIcon}
                    alt="User Menu Icon"
                    width={25}
                    id="menuSidebarHandlerImg"
                  />
                </Button>
                <div className="logo">
                  <a href="/">
                    <img src={appDetails?.LOGO_URL} alt="Logo" />
                  </a>
                </div>
                <div className="header-left ms-4 d-none d-lg-block">
                  <Navbar.Toggle
                    aria-controls="basic-navbar-nav"
                    className="d-none"
                  />
                  <Navbar.Collapse id="basic-navbar-nav" className="d-block">
                    <Nav className="me-auto">
                      {/* {<Nav.Link href="#home">New Games</Nav.Link>} */}
                      {/* <Nav.Link href="/spmsports/live">SPM Sports</Nav.Link> */}
                      {/* <Nav.Link href="/sportsbook/Inplay">Sportsbook</Nav.Link> */}
                      <Nav.Link href="/live-dealer">Live Dealers</Nav.Link>
                      <Nav.Link href="/casino/evolution">Evolution</Nav.Link>
                      <Nav.Link href="/casino/supernowa">Supernowa</Nav.Link>
                      <Nav.Link href="/casino/spribe/aviator">Aviator</Nav.Link>
                    </Nav>
                  </Navbar.Collapse>
                </div>
                <div className="headerRight ms-auto">
                  <ul className="d-none">
                    <li>
                      <a
                        className="tg"
                        href={
                          appDetails?.TELEGRAM != ""
                            ? appDetails?.TELEGRAM
                            : "#"
                        }
                        target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
                      >
                        <img src={TelegramIcon} alt="Telegram Icon" />
                      </a>
                    </li>
                    <li>
                      <a
                        className="wtp"
                        href={
                          appDetails?.WHATS_APP_URL != ""
                            ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                            : "#"
                        }
                        target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                      >
                        <img src={WhatsappIcon} alt="Whatsapp Icon" />
                      </a>
                    </li>
                    <li className="theme-btn">
                      <button
                        type="button"
                        className="btn"
                        onClick={toggleClass}
                      >
                        <img
                          src={MoonLight}
                          alt="moon"
                          className="dark_theme"
                        />
                        <img src={SunLight} alt="sun" className="light_theme" />
                      </button>
                    </li>
                  </ul>

                  <Button
                    variant="primary"
                    // onClick={() => {
                    //   navigate("/sign-in");
                    // }}
                    onClick={() => {
                      isMobile
                        ? handleModalShow(APP_CONST.AUTH_MODAL.LOGIN)
                        : navigate("/sign-in");
                    }}
                    className="login_btn me-2"
                  >
                    Sign in
                  </Button>
                  <Button
                    variant="primary"
                    onClick={() => {
                      isMobile
                        ? handleModalShow(APP_CONST.AUTH_MODAL.MOBILE_NUMBER)
                        : navigate("/mobile-number");
                    }}
                    className="signup_btn"
                  >
                    REGISTER
                  </Button>
                  <ul className="" style={{ marginLeft: "5px" }}>
                    <li>
                      <GamesSearchModal />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {showMobileSideBar && (
          <MobLeftbar
            containerRef={containerRef}
            className="d-block d-md-none"
            setShowAuthModals={setShowAuthModals}
          />
        )}
        {showAuthModals && (
          <ModalWrapper
            defaultShow={defaultModal}
            setShowAuthModals={setShowAuthModals}
          />
        )}
      </header>
    </>
  );
};

export default Header;
